import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Link from 'shared/components/Link';
import { buildJournalListingUrl } from '../../helpers/urlBuilder';
import s from './TagList.css';

class TagList extends React.Component {
  static propTypes = {
    tags: PropTypes.arrayOf(PropTypes.shape()),
    onTagClick: PropTypes.func,
    title: PropTypes.string,
    className: PropTypes.string,
    max: PropTypes.number,
    activeTag: PropTypes.string,
    url: PropTypes.string,
    query: PropTypes.shape(),
    //
    currentRubric: PropTypes.shape().isRequired,
    rubrics: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  };
  static defaultProps = {
    tags: null,
    query: null,
    url: null,
    title: null,
    className: '',
    max: null,
    onTagClick: () => {},
    activeTag: null,
  };

  state = {
    collapsed: !!this.props.activeTag,
  };

  showAll = () => {
    this.setState({ collapsed: true });
  };

  render() {
    if (!this.props.tags) {
      return null;
    }

    const {
      title,
      tags: allTags,
      max,
      className,
      onTagClick,
      activeTag,
      query,
      url,
      currentRubric,
      rubrics,
    } = this.props;
    const { collapsed } = this.state;
    const tags = max && !collapsed ? allTags.slice(0, max) : allTags;
    const clearLink = queryString.stringify({ ...query, tag: undefined });

    return (
      <div className={className || s.root}>
        {activeTag && (
          <Link to={`${url}${clearLink ? `?${clearLink}` : ''}`} className={s.clearFilters}>
            <FormattedMessage id="Очистить" />
          </Link>
        )}

        {title && <h4 className={s.title}>{title}</h4>}

        <div className={s.list}>
          {tags.map(tag => (
            <Link
              to={buildJournalListingUrl(rubrics, currentRubric, tag.slug)}
              key={tag.id || tag.title}
              onClick={() => onTagClick(tag.id)}
              className={cx(s.tag, { [s.active]: activeTag === tag.slug })}
            >
              {tag.title}{' '}
            </Link>
          ))}

          {tags.length < allTags.length && (
            <button onClick={this.showAll} className={s.tag}>
              ...
            </button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  rubrics: globals.journal.rubrics,
});

export default withStyles(s)(connect(mapStateToProps)(TagList));



// WEBPACK FOOTER //
// ./src/shared/components/TagList/TagList.js